import React from 'react';
import InfoSection from './InfoSection';
import ProjectsSection from './ProjectsSection';
import ContactSection from './ContactSection';

const Home = () => {
	return (
		<>
			<InfoSection />
			<ProjectsSection />
			<ContactSection />
		</>
	);
};

export default Home;
